export class Company {
    constructor(
      id,
      name,
      erpRRHHId,
      secondaryId,
      deletedAt,
    ) {
        this.id = id;
        this.name = name;
        this.erpRRHHId = erpRRHHId;
        this.secondaryId = secondaryId;
        this.deletedAt = deletedAt;
    }
    static createFromResponseData(data) {
      if (!data) {
        return null;
      }
      return new Company(
        data.id,
        data.name,
        data.erpRRHHId,
        data.secondaryId,
        data.deletedAt,
      );
    }
  };